<template>
  <section class="relative py-16 bg-gray-50">
    <!-- Degradado suave naranja en el fondo -->
    <div class="pointer-events-none absolute inset-0 bg-white"></div>

    <div class="relative max-w-6xl mx-auto px-4 md:px-8">
      <!-- Encabezado -->
      <header class="text-center mb-10">
        <p
          class="text-xs font-semibold tracking-[0.25em] text-gray-700 uppercase"
        >
          Visitas
        </p>
        <h2 class="mt-3 text-3xl md:text-4xl font-bold text-orange-500">
          Horarios de visitas por servicio
        </h2>
        <p class="mt-3 text-sm md:text-base text-gray-600">
          Consulta la franja de visitas y el número de acompañantes permitidos
          en cada unidad.
        </p>
      </header>

      <!-- Controles: filtros + buscador -->
      <div
        class="flex flex-col md:flex-row gap-4 md:items-center md:justify-between mb-8"
      >
        <!-- Filtros -->
        <!-- <div
          class="inline-flex bg-white rounded-full p-1 border border-gray-200 shadow-sm"
        >
          <button
            v-for="cat in categorias"
            :key="cat.id"
            @click="filtroCategoria = cat.id"
            class="px-4 py-1.5 text-xs md:text-sm rounded-full font-medium transition-all"
            :class="
              filtroCategoria === cat.id
                ? 'bg-orange-500 text-white shadow-md'
                : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
            "
          >
            {{ cat.label }}
          </button>
        </div> -->

        <!-- Buscador -->
        <!-- <div class="relative w-full md:w-72">
          <span
            class="pointer-events-none absolute inset-y-0 left-3 flex items-center text-gray-400 text-sm"
            >🔍</span
          >
          <input
            v-model="textoBusqueda"
            type="text"
            placeholder="Buscar: UCI, hospitalización..."
            class="w-full pl-9 pr-3 py-2 text-sm rounded-full bg-white border border-gray-300 text-gray-800 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-400/70 focus:border-orange-400"
          />
        </div> -->
      </div>

      <!-- Tarjetas -->
      <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <transition-group name="card-fade" tag="div" class="contents">
          <article
            v-for="servicio in horariosFiltrados"
            :key="servicio.id"
            class="group bg-white border border-gray-200 rounded-2xl p-5 flex flex-col justify-between shadow-md hover:shadow-xl hover:border-orange-400 transition-all duration-300"
          >
            <!-- Top -->
            <div>
              <!-- etiqueta + nombre -->
              <div class="flex items-center justify-between gap-3 mb-3">
                <div>
                  <p
                    class="text-[10px] font-semibold uppercase tracking-[0.2em] text-orange-500"
                  >
                    {{ servicio.etiqueta }}
                  </p>
                  <h3
                    class="mt-1 text-lg md:text-xl font-semibold text-gray-800 group-hover:text-orange-500"
                  >
                    {{ servicio.nombre }}
                  </h3>
                </div>

                <!-- chip UCI / General -->
                <span
                  class="text-[11px] px-3 py-1 rounded-full border"
                  :class="
                    servicio.esUci
                      ? 'border-orange-400 bg-orange-50 text-orange-700'
                      : 'border-gray-300 bg-gray-100 text-gray-700'
                  "
                >
                  {{ servicio.esUci ? "UCI" : "General" }}
                </span>
              </div>

              <!-- Horarios -->
              <div class="mt-3 space-y-2">
                <p class="text-[11px] font-semibold text-gray-500 uppercase">
                  Horario de visitas
                </p>

                <ul class="space-y-1.5">
                  <li
                    v-for="(linea, idx) in servicio.horario.split('\n')"
                    :key="idx"
                    class="flex items-start gap-2 text-sm text-gray-800"
                  >
                    <span class="mt-0.5 text-xs">🕒</span>
                    <span class="leading-snug">{{ linea }}</span>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Separador -->
            <div class="my-4 border-t border-gray-200"></div>

            <!-- Visitantes -->
            <div>
              <p
                class="text-[11px] font-semibold text-gray-500 uppercase mb-1.5"
              >
                Número de visitantes
              </p>
              <p class="text-sm text-gray-800 whitespace-pre-line leading-snug">
                👥 {{ servicio.visitantes }}
              </p>

              <!-- Nota opcional -->
              <p
                v-if="servicio.nota"
                class="mt-3 text-[11px] text-orange-700 bg-orange-50 border border-orange-200 rounded-xl px-3 py-2 leading-snug"
              >
                {{ servicio.nota }}
              </p>
            </div>
          </article>
        </transition-group>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from "vue";

const categorias = [
  { id: "todos", label: "Todos los servicios" },
  { id: "uci", label: "Solo UCI" },
  { id: "hospitalizacion", label: "Hospitalización" },
];

const filtroCategoria = ref("todos");
const textoBusqueda = ref("");

const horarios = [
  {
    id: "urgencias",
    nombre: "Urgencias",
    etiqueta: "Atención inmediata",
    esUci: false,
    tipo: "general",
    horario: "N.A",
    visitantes: "Un (1) acompañante.",
    nota: "",
  },
  {
    id: "hospitalizacion",
    nombre: "Hospitalización",
    etiqueta: "Piso hospitalario",
    esUci: false,
    tipo: "hospitalizacion",
    horario: "10:00 a.m. a 12:00 p.m.\n2:00 p.m. a 6:00 p.m.",
    visitantes: "Dos (2) visitantes.",
    nota: "",
  },
  {
    id: "uci-adultos",
    nombre: "UCI Adultos",
    etiqueta: "Cuidado crítico",
    esUci: true,
    tipo: "uci",
    horario: "11:00 a.m. a 12:00 p.m.\n4:00 p.m. a 5:00 p.m.",
    visitantes:
      "Dos (2) visitantes.\nSolo un familiar por paciente dentro de la UCI.",
    nota: "",
  },
  {
    id: "intermedio-adulto",
    nombre: "Intermedio Adulto",
    etiqueta: "Unidad intermedia",
    esUci: true,
    tipo: "uci",
    horario: "10:00 a.m. a 11:00 a.m.\n4:00 p.m. a 5:00 p.m.",
    visitantes: "Un (1) visitante.",
    nota: "",
  },
  {
    id: "uci-neonatos",
    nombre: "UCI Neonatos",
    etiqueta: "Cuidado neonatal",
    esUci: true,
    tipo: "uci",
    horario: "10:30 a.m. a 11:30 a.m.\n3:30 p.m. a 4:30 p.m.",
    visitantes: "Un (1) visitante.",
    nota: "",
  },
  {
    id: "uci-pediatrica",
    nombre: "UCI Pediátrica",
    etiqueta: "Cuidado pediátrico",
    esUci: true,
    tipo: "uci",
    horario:
      "11:00 a.m. a 12:00 p.m.\n4:30 p.m. a 5:30 p.m.\n\nSábados:\n10:00 a.m. a 12:00 p.m.\n2:00 p.m. a 4:00 p.m.",
    visitantes:
      "Un (1) solo familiar por paciente dentro de la UCI.\n(Recomendaciones adicionales).",
    nota: "Se estipula el horario de la mañana debido a que se realiza el aseo semanal de la unidad.",
  },
];

const horariosFiltrados = computed(() => {
  return horarios.filter((h) => {
    // Filtro por categoría
    if (filtroCategoria.value === "uci" && !h.esUci) return false;
    if (
      filtroCategoria.value === "hospitalizacion" &&
      h.id !== "hospitalizacion"
    )
      return false;

    // Filtro por texto
    if (!textoBusqueda.value) return true;
    const q = textoBusqueda.value.toLowerCase();
    return (
      h.nombre.toLowerCase().includes(q) ||
      h.etiqueta.toLowerCase().includes(q) ||
      h.horario.toLowerCase().includes(q)
    );
  });
});
</script>

<style scoped>
.card-fade-enter-active,
.card-fade-leave-active {
  transition: all 0.35s ease;
}
.card-fade-enter-from {
  opacity: 0;
  transform: translateY(14px) scale(0.98);
}
.card-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px) scale(0.98);
}
</style>
